import axios from 'axios';

// Setup global axios interceptor for Authorization token
// Note: X-Tenant-Id header is handled by AuthContext
axios.interceptors.request.use(
  (config) => {
    // Always add Authorization token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
